module.exports = __webpack_public_path__ + "static/media/bg_DL.5b2b18ad.jpg";